<template>
  <vs-card style="min-height: 150px; ">
    <vs-row vs-type="flex" vs-justify="end">
      <vs-col vs-w="12" style="display: inline-flex">
        <div class="con-input-search vs-table--search">
          <input class="input-search vs-table--search-input mt-1 w-full" type="text" style="font-size: 1.5em;"  v-model="text" @keypress.enter="search"  :placeholder="$t('search') | capitalize">
          <vs-icon icon="search"></vs-icon>
        </div>
      </vs-col>

    </vs-row>
    <vs-row>
      <vs-col>
        <table class="sticky-table w-full mt-4">
          <thead>
            <tr class="sticky-table-tr">
              <th class="sticky-table-th text-left" style="width: 30vw;">
                {{ $t('category') | capitalize }}
              </th>
              <th class="sticky-table-th text-left"  style="width: 20vw;">
                {{ $t('USD') | capitalize }}
              </th>
              <th class="sticky-table-th text-left"  style="width: 20vw;">
                {{ $t('MXN') | capitalize }}
              </th>
              <th class="sticky-table-th text-left"  style="width: 20vw;">
                {{ $t('USD_EST') | capitalize }}
              </th>
              <th class="sticky-table-th text-left"  style="width: 10vw;"> </th>
            </tr>
          </thead>
          <tbody id="table-loading" class="vs-con-loading__container">
            <tr :key="indextr" v-for="(tr, indextr) in filtered" class="sticky-table-tr">
              <td class="sticky-table-td text-left py-2">
                {{ filtered[indextr].category_name }}
              </td>
              <td class="sticky-table-td text-left">
                $ {{ formatNumber(filtered[indextr].usd, 2) }}
              </td>
              <td class="sticky-table-td text-left">
                $ {{ formatNumber(filtered[indextr].mxn, 2) }}
              </td>
              <td class="sticky-table-td text-left">
                $ {{ formatNumber(filtered[indextr].usd_est, 2) }}
              </td>
              <td class="sticky-table-td">
                <action-icon icon="EditIcon" :tooltip="$t('edit')" @click="editItem(filtered[indextr])" />
              </td>
            </tr>

          </tbody>
        </table>
      </vs-col>
    </vs-row>

  </vs-card>

</template>
<script>
import loading from '@/mixins/Loading'
import ActionIcon from '@/views/qb-components/actions/ActionIcon'
export default {
  components: {
    ActionIcon,
  },
  computed: {
    filtered() {
      return this.data.filter((el) =>
        el.category_name.toLowerCase().includes(this.text.toLowerCase().trim())
      )
    },
  },
  data() {
    return {
      text: '',
    }
  },
  methods: {
    editItem(item) {
      this.$emit('edit', item)
    },
  },
  mixins: [loading],
  watch: {
    loading(val) {
      if (val) {
        this.openLoading('table-loading')
      } else {
        this.closeLoading('table-loading')
      }
    },
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
}
</script>

<style scoped></style>
